import { c as _c } from "react/compiler-runtime";
import { Printer } from 'lucide-react';
import { useCallback } from 'react';
import { Button } from '@/components/ui/button';
import { useTranslation } from '@/hooks/use-translation';
export interface PrintButtonProps {
  label?: string;
  size?: React.ComponentProps<typeof Button>['size'];
  variant?: React.ComponentProps<typeof Button>['variant'];
}
export const PrintButton = t0 => {
  const $ = _c(8);
  const {
    label,
    size: t1,
    variant: t2
  } = t0;
  const size = t1 === undefined ? "xs" : t1;
  const variant = t2 === undefined ? "outlineStrong" : t2;
  const {
    t
  } = useTranslation();
  const print = _temp;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Printer className="size-4" />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== label || $[2] !== t) {
    t4 = label ?? t("Print");
    $[1] = label;
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== size || $[5] !== t4 || $[6] !== variant) {
    t5 = <Button variant={variant} size={size} onClick={print}>{t3}{t4}</Button>;
    $[4] = size;
    $[5] = t4;
    $[6] = variant;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
function _temp() {
  return window.print();
}